import {Component, Injector, Input, OnInit, OnDestroy} from '@angular/core';
import {LocationSummary} from '../../configuration-management/models/locations.interface';
import {LocationService} from '../../configuration-management/services/location.service';
import {FormControl, FormGroupDirective} from '@angular/forms';
import {getNestedFormControl} from '../utils/form.util';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-select-location',
  templateUrl: './select-location.component.html',
  styleUrls: ['./select-location.component.scss']
})
export class SelectLocationComponent implements OnInit, OnDestroy {
  locations: LocationSummary[];
  formSearch: FormControl = new FormControl('');
  selectedLocationNames: string[];
  private subscriptions: Subscription = new Subscription();

  @Input() control: FormControl;
  @Input() controlName: string;
  @Input() label = 'Location';
  @Input() allowAll = false;
  @Input() allowOther = false;
  @Input() allowMultiple = false;
  @Input() inventoryOnly = false;  // Option to load only inventory locations
  @Input() includeControlledSubstanceStorage = false;

  private rootFormGroup: FormGroupDirective;

  constructor(private locationService: LocationService, private injector: Injector) { }

  ngOnInit() {
    if (this.controlName) {
      this.rootFormGroup = this.injector.get(FormGroupDirective);
      this.control = getNestedFormControl(this.rootFormGroup.form, this.controlName);
      this.subscriptions.add(
        this.control.valueChanges.subscribe(this.updateSelectedLocationNames.bind(this))
      );
    }

    const locationObservable = this.includeControlledSubstanceStorage
      ? this.locationService.getControlledSubstanceInventoryLocations()
      : this.inventoryOnly 
        ? this.locationService.getInventoryLocations()
        : this.locationService.index();

    locationObservable.subscribe(res => {
      this.locations = res.sort((a, b) => a.name.localeCompare(b.name));
      this.updateSelectedLocationNames();
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private updateSelectedLocationNames() {
    if (!this.locations || !this.control.value) {
      this.selectedLocationNames = [];
      return;
    }

    const selected = this.locations.filter(location =>
      Array.isArray(this.control.value)
        ? this.control.value.includes(location.id)
        : this.control.value === location.id
    );
    this.selectedLocationNames = selected.map(location => location.name);

    // Add "Other" to the selected names if it's selected
    if (Array.isArray(this.control.value) && this.control.value.includes('')) {
      this.selectedLocationNames.push('Other');
    } else if (this.control.value === '') {
      this.selectedLocationNames = ['Other'];
    }
  }
}